import z from 'zod';
import {
  ApplicationCategory,
  ApplicationProgressReportingFrequency,
  ApplicationTeamType,
} from '../ApplicationsList/ApplicationsList.types';
import { FormStep } from '../../Form/FormContext';

export const APPLICATION_STORAGE_KEY = 'applicationFormDraft';

export const applicationFormSchema = z.object({
  name: z.string().min(1, 'This field is required'),
  description: z.string().min(3, 'This field is required'),
  applicant: z.string().min(1, 'This field is required'),
  teamType: z.nativeEnum(ApplicationTeamType, {
    message: 'This field is required',
  }),
  teamDescription: z.string().min(3, 'This field is required'),
  email: z
    .string()
    .min(1, {
      message: 'This field is required',
    })
    .email(),
  fundingRequest: z
    .number({
      coerce: true,
      invalid_type_error: 'This field is required',
    })
    .min(0, 'This field is required'),
  detailedBudget: z.string().min(3, 'This field is required'),
  dateRange: z.object(
    {
      from: z.coerce.date(),
      to: z.coerce.date(),
    },
    {
      message: 'This field is required',
    },
  ),
  milestones: z.string().min(3, 'This field is required'),
  rationale: z.string().min(3, 'This field is required'),
  categories: z
    .array(z.nativeEnum(ApplicationCategory))
    .min(1, 'This field is required'),
  progressReportingFrequency: z.nativeEnum(
    ApplicationProgressReportingFrequency,
    {
      message: 'This field is required',
    },
  ),
  demoURL: z.string().url().optional().or(z.literal('')),
});

export type ApplicationFormSchema = z.TypeOf<typeof applicationFormSchema>;

export const applicationFormSteps: FormStep<ApplicationFormSchema>[] = [
  {
    title: 'Apply for a Beam grant',
    description:
      'We’re funding builders, creators, and teams who want to advance Beam with grants.',
    fieldNames: ['name', 'description'],
  },
  {
    title: 'Introduce your team',
    fieldNames: ['applicant', 'teamType', 'teamDescription', 'email'],
  },
  {
    title: 'Funding & roadmap',
    fieldNames: ['fundingRequest', 'detailedBudget', 'dateRange', 'milestones'],
  },
  {
    title: 'Why Beam Foundation should fund you',
    fieldNames: ['rationale', 'categories', 'progressReportingFrequency'],
  },
  {
    title: 'Share extra details',
    subtitle: '(optional)',
    fieldNames: ['demoURL'],
  },
];
